/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useRef} from 'react';
import {useRouter} from 'next/compat/router';
import RouterManager from '../routes/RouteManager';
/**
 * This hook initializes the global RouterManager with the Next.js router
 * instance. It should be called once on the client side, typically
 * inside `_app.tsx` or a layout component. Ensures that your non-component
 * code (e.g. Redux, services) can access router actions like navigation.
 * 
 * ```typescript
 * 
 * useRouteInitializer(); // In _app.tsx or top-level layout
 * 
 * ```
 */
const useRouteInitializer = () => {
  const initializedRef = useRef(false);
  const router         = useRouter();

  useEffect(() => {
    if (router && !initializedRef.current) {
      RouterManager.initialize(router);
      initializedRef.current = true;
    }
  }, [router]);
};

export default useRouteInitializer;
